import { SearchService } from './search.service';
import { SearchResponse } from './../../../models/search-response';
import { HttpParams } from '@angular/common/http';
import { debounceTime, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { SearchResultsComponent } from '../search-results/search-results.component';

@Component({
    selector: 'pdp-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, MatButton, SearchResultsComponent]
})
export class SearchComponent {
  private unsubscribe: Subject<void> = new Subject();

  public searchResponse: SearchResponse;

  public closeDropdown(closed: any) {
    this.searchResponse = null;
    this.formGroup.patchValue({
      'searchInput': null
    })
  }

  public formGroup: UntypedFormGroup;
  constructor(public activatedRoute: ActivatedRoute,
    public router: Router,
    private searchService: SearchService,
    public formBuilder: UntypedFormBuilder) {
    this.formGroup = this.formBuilder.group({
      'searchInput': new UntypedFormControl()
    })
    this.formGroup.get('searchInput')
      .valueChanges
      .pipe(
        debounceTime(200),
        filter(query => query !== null),
        filter(query => typeof query === 'string'),
        takeUntil(this.unsubscribe))
      .subscribe((query: string) => {
        if (query != '') {
          let httpParams: HttpParams = new HttpParams();
          httpParams = httpParams.append('q', query);
          httpParams = httpParams.append('size', 5 + '');
          this.searchService.performSearch(httpParams).pipe(
            takeUntil(this.unsubscribe))
            .subscribe((searchResponse: SearchResponse) => {
              this.searchResponse = searchResponse;
            });
        } else {
          this.searchResponse = null;
        }
      })
  }

  public doSearch() {
    let value = this.formGroup.value['searchInput'];
    if (value) {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          'q': value,
          'page': '0',
          'size': '30',
          'sortBy': 'price',
          'sortOrder': 'asc'
        },
        relativeTo: this.activatedRoute
      };
      value = '';
      this.router.navigate(['/search'], navigationExtras);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
